import React from 'react';
import { useGetLiveDisplayQuery, useUpdateLiveDisplayMutation } from '../../../../generated/core-api/graphql-react-query';
import useIsWindowVisible from '../../../LiveContext/Hooks/useIsWindowVisible';
import useGlobalStoreContext from '../Contexts/GlobalStoreContext/useGlobalStoreContext';
import useUpdateDisplay from './useUpdateDisplay';

export default function useVisibilityDisplayUpdate() {
  const { displayId: [displayId] } = useGlobalStoreContext();
  const display = useGetLiveDisplayQuery({ input: { id: displayId ?? '' } }, { enabled: !!displayId });
  const { isVisible } = useIsWindowVisible();
  const updateMutation = useUpdateLiveDisplayMutation({
    onSuccess(data) {
      updateDisplay(data.updateDisplay);
    },
    onError(error) { console.error(`Error updating visibility of display "${displayId}"`, error); },
  });

  const updateDisplay = useUpdateDisplay();
  React.useEffect(() => {
    if (display.data?.getDisplay) {
      if (display.data.getDisplay.isVisible !== isVisible && isVisible) {
        updateMutation.mutate(
          {
            input: {
              id: display.data.getDisplay.id,
              isVisible,
            },
          },
        );
      }
    }
  }, [isVisible, display.data]);
}
